import { render, staticRenderFns } from "./FormsConfigurationSection.vue?vue&type=template&id=5f86a304&scoped=true"
import script from "./FormsConfigurationSection.vue?vue&type=script&lang=js"
export * from "./FormsConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86a304",
  null
  
)

export default component.exports